import { bootstrapApplication } from '@angular/platform-browser';
import { App } from '../app/app';
import { appConfig } from '../config/app.config';

// Invece di esportare una funzione, la eseguiamo direttamente
bootstrapApplication(App, appConfig)
    .catch((err) => console.error(err));